module.exports = __webpack_public_path__ + "img/morningRef2_thumb.43274447.jpg";